<template>
  <input-select ref="select" v-model="value" caption="Выберите предприятие..." :itemList="items"></input-select>
</template>

<script>
export default {
  props: ['model-value'],
  emits: ['update:model-value'],
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:model-value', value)
      }
    },
    items() {
      return this.$store.getters['getParks'].map(item => {

        return {
          id: item.parkId,
          title: item.parkTitleLong
        }
      });

    }
  },
  methods: {
    validate() {
      return this.$refs.select.validate()
    }
  }
}
</script>
